import { render, staticRenderFns } from "./menuUser.vue?vue&type=template&id=549bebfa&scoped=true&"
import script from "./menuUser.vue?vue&type=script&lang=js&"
export * from "./menuUser.vue?vue&type=script&lang=js&"
import style0 from "./menuUser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./menuUser.vue?vue&type=style&index=1&id=549bebfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549bebfa",
  null
  
)

/* custom blocks */
import block0 from "./menuUser.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports